import { lineNumbers as t, highlightActiveLineGutter as e, highlightSpecialChars as i, drawSelection as o, dropCursor as r, rectangularSelection as a, crosshairCursor as l, highlightActiveLine as m, keymap as p } from "./ghl-ui.es269.js";
import { EditorView as V } from "./ghl-ui.es269.js";
import { EditorState as h } from "./ghl-ui.es268.js";
import { foldGutter as c, indentOnInput as n, syntaxHighlighting as s, bracketMatching as f, foldKeymap as g, defaultHighlightStyle as u } from "./ghl-ui.es424.js";
import { history as y, defaultKeymap as d, historyKeymap as S } from "./ghl-ui.es262.js";
import { highlightSelectionMatches as K, searchKeymap as k } from "./ghl-ui.es435.js";
import { closeBrackets as b, autocompletion as w, closeBracketsKeymap as x, completionKeymap as C } from "./ghl-ui.es430.js";
import { lintKeymap as M } from "./ghl-ui.es267.js";
const I = /* @__PURE__ */ (() => [
  t(),
  e(),
  i(),
  y(),
  c(),
  o(),
  r(),
  h.allowMultipleSelections.of(!0),
  n(),
  s(u, { fallback: !0 }),
  f(),
  b(),
  w(),
  a(),
  l(),
  m(),
  K(),
  p.of([
    ...x,
    ...d,
    ...k,
    ...S,
    ...g,
    ...C,
    ...M
  ])
])();
export {
  V as EditorView,
  I as basicSetup
};
